export interface ITaskDocument {
    $type: string;
    Id: string;
    ImportTrackingId: string;
    Company: {
        Name: string
    }
    WrappedDocumentType: string;
    MappedContent:{
        $type: string;
    },
    DocumentType: string;
}

export interface IActivityContext {
    Name: string;
}